import React, { useState, useEffect } from 'react';
import GoogleMap from 'google-map-react'; // GoogleMapReact

import { PointOfSaleMapTeaser } from '/components/point-of-sale-map/PointOfSaleMapTeaser';

import '/components/point-of-sale-map/point-of-sale-map.scss';

const getMapBounds = (map, maps, locations) => {
    const bounds = new maps.LatLngBounds();

    locations.filter(location => location.lat && location.lng).forEach((location) => {
        bounds.extend(new maps.LatLng(
            location.lat,
            location.lng,
        ));
    });

    return bounds;
};

const resizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, 'idle', () => {
        maps.event.addDomListener(window, 'resize', () => {
            map.fitBounds(bounds);
        });
    });
};

const apiIsLoaded = (map, maps, locations) => {
    const bounds = getMapBounds(map, maps, locations);

    map.fitBounds(bounds);
    resizeListener(map, maps, bounds);
};

const PointOfSaleMap = () => {
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        const fetcher = async () => {
            try {
                const response = await fetch('/api/points-of-sale');
                const json = await response.json();

                setLocations(json.data);
            } catch (error) {
                // do nothing
            }
        };

        fetcher().then();
    }, []);

    if (locations.length === 0) {
        return null;
    }

    return (
        <div className="point-of-sale-map-wrapper">
            <GoogleMap
                className="test"
                bootstrapURLKeys={{ key: 'AIzaSyD9hmyMtGQU1RnXKUgJK1LZQNXsH5mS6xE' }}
                defaultCenter={{ lat: 50.797402, lng: 4.652166 }}
                defaultZoom={11}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, locations)}
            >
                {locations.map((location) => (
                    <PointOfSaleMapTeaser location={location} lat={location.lat} lng={location.lng} key={location.id} />
                ))}
            </GoogleMap>
        </div>
    );
};

export { PointOfSaleMap };
